import { List, Typography } from 'antd';
import React, { memo, useMemo } from 'react';
import { CALL_SESSION_TYPE, CALL_SOURCE, CONTACT_PREVIEWS, pickByNumber, pickRandom } from 'utils';
import AICallItem from './AICallItem';
import { aiAgentCenterMessages } from 'messages';
import { useAIAgentCenterContext } from 'contexts/ai-agent-center';
import { useOmniCallSessionInprogressList, useSystemConfigAIAgent } from 'hooks';
import { InView } from 'react-intersection-observer';

type AICallListProps = {};

const AICallList: React.FC<AICallListProps> = () => {
  const { callSession, setCallSession, filterForm } = useAIAgentCenterContext();
  const { isLoading, data: configAI } = useSystemConfigAIAgent();

  const { callSource } = filterForm || {};

  const {
    callSessionInprogress: data,
    handleLoadMore,
    hasMore
  } = useOmniCallSessionInprogressList({
    callSource,
    isHandleByAi: true
  });

  return (
    <div className='h-full max-h-full w-full overflow-y-auto'>
      <div className='flex h-11 items-center px-5'>
        <Typography.Text className='text-xs font-semibold uppercase text-colorTextPlaceholder'>
          {aiAgentCenterMessages.countActive(configAI?.concurrency ?? 0, configAI?.maxConcurrency ?? 0)}
        </Typography.Text>
      </div>
      <List
        className='w-full pb-5'
        dataSource={data}
        renderItem={(item) => (
          <AICallItem
            item={item}
            selected={callSession?.callSessionId === item.callSessionId}
            onSelect={() => {
              setCallSession(item);
            }}
          />
        )}
        rowKey={'callSessionId'}
        footer={
          hasMore ? (
            <InView
              className='-mt-3'
              onChange={(open) => {
                console.log('InView changed:', open);
                if (open) {
                  handleLoadMore();
                }
              }}
            >
              <div className='flex h-18 gap-3 px-5 py-3'>
                <div>
                  <div className='skeleton-active h-12 w-12 rounded-full'></div>
                </div>
                <div className='mt-[3px] flex flex-1 flex-col gap-1'>
                  <div className='skeleton-active h-5 w-[180px] rounded-sm'></div>
                  <div className='skeleton-active h-[18px] w-[100px] rounded-sm'></div>
                </div>
                <div className='mt-[3px] h-full'>
                  <div className='skeleton-active h-[14px] w-[40px] rounded-sm'></div>
                </div>
              </div>
            </InView>
          ) : null
        }
      />
    </div>
  );
};

export default memo(AICallList);
